var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center justify-center h-100 py-16"},[_c('div',{staticClass:"mt-32",class:_vm.containerClass},[_c('h2',{staticClass:"text-center indigo--text text--darken-2"},[_vm._v("Store Payment")]),_c('AccountPayment',{staticClass:"mt-8"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }